import examinationItem from './examinationItem.vue';

export * from './types';
export default examinationItem;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/examination-item/index.ts